/*
  Mauve Lane · comportamento do topo e do rodapé (layout da referência, ramo "marimaria").
  Carregado por sections/header.liquid em todas as páginas.

  - barra de aviso: troca de frase com esmaecimento
  - cabeçalho: marca "rolado" a partir de 1 px de rolagem (fundo branco na página inicial) e, enquanto está
    no desenho de celular (até 1025 px, ou mais largo com data-mm-topo-estreito), recolhe o topo ao rolar
    para baixo (fica só a linha do logo) e devolve ao rolar para cima
  - menu: lista de subcategorias de cada categoria (com o cursor e o teclado quem abre é o CSS; no toque,
    o primeiro toque abre e o segundo segue o link)
  - busca: painel com categorias e, digitando, sugestões e produtos da busca preditiva da Shopify
  - gaveta do menu e lista de desejos (as duas em <dialog>)
  - botão "Back to top"

  A página rola na janela até 989 px e dentro de .page-wrapper de 990 px para cima (Horizon).
*/
(function () {
  'use strict';

  if (window.__veluneMmHeader) return;
  window.__veluneMmHeader = true;

  var doc = document;
  var root = doc.documentElement;

  function $(selector, scope) {
    return (scope || doc).querySelector(selector);
  }

  function $all(selector, scope) {
    return Array.prototype.slice.call((scope || doc).querySelectorAll(selector));
  }

  function pageWrapper() {
    return $('.page-wrapper');
  }

  function scrollTop() {
    var wrapper = pageWrapper();
    return Math.max(window.scrollY || 0, root.scrollTop || 0, wrapper ? wrapper.scrollTop : 0);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(root.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (error) {
      return '$' + Number(amount).toFixed(2);
    }
  }

  function el(tag, className, text) {
    var node = doc.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /* ---------------------------------------------------------------- */
  /* Barra de aviso                                                   */
  /* ---------------------------------------------------------------- */
  function initAviso() {
    var bar = $('[data-mm-aviso]');
    if (!bar || bar.dataset.mmPronto) return;
    bar.dataset.mmPronto = 'true';

    var phrases = $all('[data-mm-aviso-frase]', bar);
    if (phrases.length < 2) return;

    var seconds = parseFloat(bar.dataset.intervalo || '3') || 3;
    var current = 0;
    phrases.forEach(function (phrase, index) {
      phrase.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });

    window.setInterval(function () {
      if (doc.hidden) return;
      phrases[current].setAttribute('aria-hidden', 'true');
      current = (current + 1) % phrases.length;
      phrases[current].setAttribute('aria-hidden', 'false');
    }, seconds * 1000);
  }

  /* ---------------------------------------------------------------- */
  /* Cabeçalho: estado "rolado" e topo recolhido                      */
  /* ---------------------------------------------------------------- */
  /*
    Topo recolhido: enquanto o cabeçalho está no desenho de celular, rolar para baixo tira a barra de aviso
    e a linha da busca e deixa só a linha do logo; rolar para cima traz tudo de volta. O CSS só desloca e
    recorta o bloco (data-mm-recolhido no #header-group), sem mudar a altura de nada, então a página não
    pula e a rolagem não treme.
    O desenho de celular vale até 1025 px de largura e também em janela mais larga quando o topo fica
    espremido (data-mm-topo-estreito no <html>, posto por sections/header.liquid com a gaveta do carrinho
    aberta). Quem rola é a janela até 989 px e o .page-wrapper de 990 px para cima: as duas rolagens são
    ouvidas e a posição é a maior das duas, então vale para qualquer largura.
    Não recolhe perto do começo da página, com a busca em uso nem com o foco do teclado dentro do topo.
    Na página de produto, de 1024 px para cima, as colunas que grudam abaixo do topo acompanham a altura
    dele no momento (assets/velune-mm-product.css, pelo mesmo data-mm-recolhido).
  */
  var topo = {
    /* devolve o topo inteiro (usado pela lupa da linha do logo) */
    expand: function () {},
  };

  function initRolagem() {
    var header = doc.getElementById('header-component');
    if (!header) return;
    var group = doc.getElementById('header-group');
    var narrow = window.matchMedia ? window.matchMedia('(max-width: 1025px)') : null;

    var SLACK = 6; /* px: rolagem menor que isto não conta como mudança de direção */
    var collapsed = false;
    var lastY = 0;

    /* o cabeçalho está no desenho de celular (o mesmo critério do CSS)? */
    function mobileDesign() {
      return Boolean(narrow && narrow.matches) || root.hasAttribute('data-mm-topo-estreito');
    }

    /* posição da rolagem sem o "elástico" do iPhone (acima do começo e além do fim da página) */
    function position() {
      var wrapper = pageWrapper();
      var max = Math.max(
        root.scrollHeight - window.innerHeight,
        wrapper ? wrapper.scrollHeight - wrapper.clientHeight : 0,
        0
      );
      return Math.min(Math.max(scrollTop(), 0), max);
    }

    function inUse() {
      if (header.hasAttribute('data-mm-ativo')) return true;
      var active = doc.activeElement;
      if (!active || active === doc.body || !group.contains(active)) return false;
      if (active.closest('[data-mm-busca]')) return true;
      try {
        return active.matches(':focus-visible');
      } catch (error) {
        return true;
      }
    }

    function setCollapsed(value) {
      if (collapsed === value) return;
      collapsed = value;
      group.toggleAttribute('data-mm-recolhido', value);
    }

    function updateCollapse() {
      var y = position();
      if (!mobileDesign() || y <= group.offsetHeight || inUse()) {
        setCollapsed(false);
        lastY = y;
        return;
      }
      var delta = y - lastY;
      if (Math.abs(delta) < SLACK) return;
      lastY = y;
      setCollapsed(delta > 0);
    }

    var ticking = false;
    function update() {
      ticking = false;
      var scrolled = scrollTop() > 0;
      header.toggleAttribute('data-mm-rolado', scrolled);
      /* O tema usa data-sticky-state="active" para descer a coluna de compra do produto abaixo do topo grudado.
         O observador do Horizon não vê este topo sair da tela (ele gruda inteiro), então o estado é marcado aqui. */
      if (header.hasAttribute('sticky')) {
        var state = scrolled ? 'active' : 'inactive';
        if (header.dataset.stickyState !== state) header.dataset.stickyState = state;
      }
      if (group) updateCollapse();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    if (group) {
      lastY = position();

      topo.expand = function () {
        setCollapsed(false);
        lastY = position();
      };

      /* o teclado chegou a uma parte do topo: mostra o topo inteiro */
      group.addEventListener('focusin', function () {
        if (collapsed && inUse()) topo.expand();
      });

      /* o topo passou para o desenho de computador (janela alargada, tablet virado, gaveta do carrinho
         fechada): desfaz o recolhido */
      if (narrow && narrow.addEventListener) narrow.addEventListener('change', onScroll);
      if ('MutationObserver' in window) {
        new MutationObserver(onScroll).observe(root, { attributes: true, attributeFilter: ['data-mm-topo-estreito'] });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    var wrapper = pageWrapper();
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('pageshow', update);
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------------------------------------------------------------- */
  /* Menu do computador                                               */
  /* ---------------------------------------------------------------- */
  /*
    O nome da categoria é sempre um link para a página dela. A lista de subcategorias (.mm-submenu) abre:
    - com o cursor em cima: pelo CSS (:hover);
    - com o foco do teclado: data-foco no item. Não dá para deixar isso com o CSS (:focus-within), porque
      na passagem do foco do nome para a lista o navegador veria a lista escondida e o foco se perderia;
    - no toque: o primeiro toque abre (data-aberto) e o segundo segue o link.
    Fecha ao sair, com Esc, ao tocar fora e quando a página volta do histórico.
  */
  function initMenu() {
    var nav = $('[data-mm-nav]');
    if (!nav) return;
    var parents = $all('.mm-nav__item--pai', nav);
    if (!parents.length) return;

    var closedItem = null;

    function linkOf(item) {
      return $('.mm-nav__link', item);
    }

    function setExpanded(item, expanded) {
      var link = linkOf(item);
      if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function setOpen(item, open) {
      item.toggleAttribute('data-aberto', open);
      if (!open) item.removeAttribute('data-foco');
      setExpanded(item, open);
    }

    function closeAll(except) {
      parents.forEach(function (item) {
        if (item !== except) setOpen(item, false);
      });
    }

    function reopenable() {
      closedItem = null;
      nav.removeAttribute('data-fechado');
    }

    /* A lista nasce alinhada ao nome da categoria; se passar da borda do miolo da página (a margem lateral
       do menu, a mesma do .mm-container), anda para dentro. */
    function fit() {
      var bounds = nav.getBoundingClientRect();
      if (!bounds.width) return;
      var list = $('.mm-nav__lista', nav);
      var margin = (list && parseFloat(window.getComputedStyle(list).paddingLeft)) || 16;
      parents.forEach(function (item) {
        var sub = $('.mm-submenu', item);
        if (!sub) return;
        sub.style.removeProperty('--mm-sub-desvio');
        var box = sub.getBoundingClientRect();
        if (!box.width) return;
        var over = box.right - (bounds.right - margin);
        var under = bounds.left + margin - box.left;
        var shift = over > 0 ? -over : under > 0 ? under : 0;
        if (shift) sub.style.setProperty('--mm-sub-desvio', Math.round(shift) + 'px');
      });
    }

    parents.forEach(function (item) {
      var link = linkOf(item);

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        reopenable();
        /* o foco do teclado parado em outra categoria deixaria duas listas abertas */
        var active = doc.activeElement;
        var other = active && active.closest ? active.closest('.mm-nav__item--pai') : null;
        if (other && other !== item && nav.contains(other)) active.blur();
        closeAll(item);
        setExpanded(item, true);
      });

      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        if (!item.hasAttribute('data-aberto') && !item.hasAttribute('data-foco')) setExpanded(item, false);
      });

      item.addEventListener('focusin', function (event) {
        /* depois de Esc, a lista deste item só volta quando o foco passar por outro item */
        if (closedItem === item) return;
        reopenable();
        var target = event.target;
        if (!target || !target.matches || !target.matches(':focus-visible')) return;
        item.setAttribute('data-foco', '');
        setExpanded(item, true);
      });

      item.addEventListener('focusout', function (event) {
        if (item.contains(event.relatedTarget)) return;
        setOpen(item, false);
      });

      /* No toque, o primeiro toque abre a lista e o segundo segue o link. */
      if (link) {
        var lastPointer = '';
        link.addEventListener('pointerdown', function (event) {
          lastPointer = event.pointerType;
        });
        link.addEventListener('click', function (event) {
          var touch = lastPointer === 'touch';
          lastPointer = '';
          if (!touch || item.hasAttribute('data-aberto')) return;
          event.preventDefault();
          reopenable();
          closeAll(item);
          setOpen(item, true);
        });
      }
    });

    doc.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var active = doc.activeElement;
      var item = active && active.closest ? active.closest('.mm-nav__item--pai') : null;
      if (item && !nav.contains(item)) item = null;
      var anyOpen = parents.some(function (parent) {
        return parent.hasAttribute('data-aberto') || parent.hasAttribute('data-foco') || parent.matches(':hover');
      });
      if (!item && !anyOpen) return;
      closeAll(null);
      closedItem = item;
      nav.setAttribute('data-fechado', '');
      if (item) {
        var link = linkOf(item);
        if (link) link.focus();
      }
    });

    nav.addEventListener('pointerleave', function () {
      if (closedItem && closedItem.contains(doc.activeElement)) return;
      reopenable();
    });

    doc.addEventListener('pointerdown', function (event) {
      if (nav.contains(event.target)) return;
      closeAll(null);
    });

    /* Voltando pelo histórico, a página reaparece como estava: nada de lista aberta nem foco preso no menu. */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      closeAll(null);
      reopenable();
      if (nav.contains(doc.activeElement)) doc.activeElement.blur();
    });

    fit();
    window.addEventListener('load', fit);
    if (doc.fonts && doc.fonts.ready && doc.fonts.ready.then) doc.fonts.ready.then(fit);
    if ('ResizeObserver' in window) {
      new ResizeObserver(fit).observe(nav);
    } else {
      window.addEventListener('resize', fit, { passive: true });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Janelas e gavetas (<dialog>)                                     */
  /* ---------------------------------------------------------------- */
  var openDialogs = 0;

  function lockScroll(lock) {
    openDialogs = Math.max(0, openDialogs + (lock ? 1 : -1));
    root.classList.toggle('mm-trava', openDialogs > 0);
  }

  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    dialog.classList.remove('mm-saindo');
    dialog.__mmOpener = opener || doc.activeElement;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    lockScroll(true);
    if (controls(opener, dialog)) opener.setAttribute('aria-expanded', 'true');
  }

  function controls(opener, dialog) {
    return Boolean(
      opener && opener.getAttribute && opener.hasAttribute('aria-expanded') && opener.getAttribute('aria-controls') === dialog.id
    );
  }

  function closeDialog(dialog, immediate) {
    if (!dialog || !dialog.open) return;
    var slides = dialog.classList.contains('mm-gaveta') || dialog.classList.contains('mm-desejos');

    function finish() {
      dialog.classList.remove('mm-saindo');
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    if (slides && !immediate && !reducedMotion()) {
      dialog.classList.add('mm-saindo');
      window.setTimeout(finish, 280);
    } else {
      finish();
    }
  }

  function initDialog(dialog) {
    if (!dialog || dialog.dataset.mmPronto) return;
    dialog.dataset.mmPronto = 'true';

    dialog.addEventListener('close', function () {
      lockScroll(false);
      var opener = dialog.__mmOpener;
      if (controls(opener, dialog)) opener.setAttribute('aria-expanded', 'false');
      if (opener && opener.isConnected && typeof opener.focus === 'function' && !dialog.__mmSemFoco) opener.focus();
      dialog.__mmSemFoco = false;
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog(dialog);
    });

    /* clique fora (no véu) fecha */
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var box = dialog.getBoundingClientRect();
      var inside =
        event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom;
      if (!inside) closeDialog(dialog);
    });

    $all('[data-mm-fechar]', dialog).forEach(function (button) {
      button.addEventListener('click', function () {
        closeDialog(dialog);
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Gaveta do menu                                                   */
  /* ---------------------------------------------------------------- */
  function initGaveta() {
    var drawer = $('[data-mm-gaveta]');
    var opener = $('[data-mm-gaveta-abrir]');
    if (!drawer || !opener) return;
    initDialog(drawer);

    opener.addEventListener('click', function () {
      openDialog(drawer, opener);
    });

    /* A gaveta só existe no desenho de celular: se o topo passar para o de computador com ela aberta, fecha. */
    if (window.matchMedia) {
      var wide = window.matchMedia('(min-width: 1026px)');
      var onWide = function () {
        if (wide.matches && !root.hasAttribute('data-mm-topo-estreito')) closeDialog(drawer, true);
      };
      if (wide.addEventListener) wide.addEventListener('change', onWide);
    }

    var cartButton = $('[data-mm-gaveta-carrinho]', drawer);
    if (cartButton) {
      cartButton.addEventListener('click', function () {
        drawer.__mmSemFoco = true;
        closeDialog(drawer, true);
        var trigger = $('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Lista de desejos                                                 */
  /* ---------------------------------------------------------------- */
  function initDesejos() {
    var drawer = $('[data-mm-desejos]');
    var counters = $all('[data-mm-desejos-conta]');
    var openers = $all('[data-mm-desejos-abrir]');
    var productCache = {};

    function api() {
      return window.VeluneWishlist || null;
    }

    function handles() {
      var wishlist = api();
      if (!wishlist) return [];
      try {
        if (typeof wishlist.list === 'function') return wishlist.list() || [];
        if (Array.isArray(wishlist.handles)) return wishlist.handles;
      } catch (error) {
        /* sem lista */
      }
      return [];
    }

    function updateCount(count) {
      var total = typeof count === 'number' ? count : handles().length;
      counters.forEach(function (counter) {
        counter.textContent = total > 99 ? '99+' : String(total);
        counter.hidden = total === 0;
      });
      openers.forEach(function (button) {
        button.setAttribute('aria-label', total > 0 ? 'Wishlist (' + total + ')' : 'Wishlist');
      });
    }

    function fetchProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      var base = (drawer && drawer.dataset.raiz) || '/';
      if (base.charAt(base.length - 1) !== '/') base += '/';
      productCache[handle] = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .catch(function () {
          delete productCache[handle];
          return null;
        });
      return productCache[handle];
    }

    function imageUrl(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function renderItem(product, handle) {
      var item = el('li', 'mm-desejos__item');
      item.dataset.handle = handle;
      var url = product.url || ((drawer.dataset.raiz || '/') + 'products/' + handle);

      var photo = el('a', 'mm-desejos__foto');
      photo.href = url;
      photo.tabIndex = -1;
      photo.setAttribute('aria-hidden', 'true');
      if (product.featured_image) {
        var img = doc.createElement('img');
        img.src = imageUrl(product.featured_image, 144);
        img.alt = '';
        img.width = 72;
        img.height = 72;
        img.loading = 'lazy';
        photo.appendChild(img);
      }

      var text = el('div');
      var name = el('a', 'mm-desejos__nome', product.title || handle);
      name.href = url;
      text.appendChild(name);
      if (typeof product.price === 'number') {
        text.appendChild(el('span', 'mm-desejos__preco', formatMoney(product.price / 100, drawer.dataset.moeda)));
      }

      var remove = el('button', 'mm-desejos__tirar');
      remove.type = 'button';
      remove.setAttribute('aria-label', (drawer.dataset.rotuloTirar || 'Remove') + ': ' + (product.title || handle));
      remove.innerHTML =
        '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11"/></svg>';
      remove.addEventListener('click', function () {
        var wishlist = api();
        if (wishlist && typeof wishlist.remove === 'function') wishlist.remove(handle);
      });

      item.appendChild(photo);
      item.appendChild(text);
      item.appendChild(remove);
      return item;
    }

    var renderToken = 0;
    function renderList() {
      if (!drawer) return;
      var list = $('[data-mm-desejos-lista]', drawer);
      var empty = $('[data-mm-desejos-vazio]', drawer);
      if (!list) return;
      var current = handles();
      var token = ++renderToken;

      if (empty) empty.hidden = current.length > 0;
      if (!current.length) {
        list.textContent = '';
        return;
      }

      Promise.all(current.map(fetchProduct)).then(function (products) {
        if (token !== renderToken) return;
        list.textContent = '';
        var shown = 0;
        products.forEach(function (product, index) {
          if (!product) return;
          list.appendChild(renderItem(product, current[index]));
          shown += 1;
        });
        if (empty) empty.hidden = shown > 0;
      });
    }

    if (drawer) {
      initDialog(drawer);
      openers.forEach(function (button) {
        button.addEventListener('click', function () {
          var menuDrawer = button.closest('[data-mm-gaveta]');
          if (menuDrawer) {
            menuDrawer.__mmSemFoco = true;
            closeDialog(menuDrawer, true);
          }
          renderList();
          openDialog(drawer, menuDrawer ? $('[data-mm-gaveta-abrir]') : button);
        });
      });
    }

    doc.addEventListener('velune:wishlist-change', function (event) {
      var detail = event.detail || {};
      updateCount(typeof detail.count === 'number' ? detail.count : undefined);
      if (drawer && drawer.open) renderList();
    });

    updateCount();
    window.addEventListener('load', function () {
      updateCount();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Busca                                                            */
  /* ---------------------------------------------------------------- */
  function initBusca() {
    var box = $('[data-mm-busca]');
    if (!box) return;
    var header = doc.getElementById('header-component');
    var input = $('.mm-busca__campo', box);
    var panel = $('.mm-busca__painel', box);
    var start = $('[data-mm-busca-inicio]', box);
    var emptyNote = $('[data-mm-busca-vazio]', box);
    var result = $('[data-mm-busca-resultado]', box);
    var suggestionList = $('[data-mm-busca-sugestoes]', box);
    var suggestionGroup = $('[data-mm-busca-grupo-sugestoes]', box);
    var categoryList = $('[data-mm-busca-categorias]', box);
    var categoryGroup = $('[data-mm-busca-grupo-categorias]', box);
    var productList = $('[data-mm-busca-produtos]', box);
    var allLink = $('[data-mm-busca-todos]', box);
    if (!input || !panel) return;

    var suggestUrl = box.dataset.url || '/search/suggest';
    var searchUrl = box.dataset.buscaUrl || '/search';
    var hideId = box.dataset.ocultar ? String(box.dataset.ocultar) : '';
    var currency = box.dataset.moeda || 'USD';
    var cache = {};
    var timer = 0;
    var requestId = 0;

    var status = $('[data-mm-busca-status]', box);

    /* A lista de categorias do painel (snippets/search.liquid) acompanha o menu: a categoria que saiu dele
       por não ter produto à venda (data-mm-vazias, em snippets/header-drawer.liquid) sai daqui também.
       A lista traz as categorias e as subcategorias vazias; as mesmas saem das sugestões da busca. */
    var menuDrawer = $('[data-mm-gaveta]');
    var emptyUrls = menuDrawer && menuDrawer.dataset.mmVazias ? menuDrawer.dataset.mmVazias.split('|') : [];

    /* só o caminho do endereço, sem domínio, parâmetros (a busca põe "?_pos=…") nem barra no fim */
    function pathOf(url) {
      try {
        return new URL(url, window.location.href).pathname.replace(/\/+$/, '').toLowerCase();
      } catch (error) {
        return String(url || '');
      }
    }

    var emptyPaths = emptyUrls
      .filter(function (url) {
        return url !== '';
      })
      .map(pathOf);
    if (start && emptyUrls.length) {
      $all('.mm-busca__termo', start).forEach(function (link) {
        if (emptyUrls.indexOf(link.getAttribute('href')) === -1) return;
        var item = link.closest('li');
        if (item) item.remove();
      });
    }

    /* Chave para comparar uma busca sugerida com o nome de uma categoria: sem caixa, acento, pontuação nem
       plural ("lip oil" e "Lip Oil", "eyes" e "Eyes", "brush" e "Brushes" dão a mesma chave). */
    function keyOf(text) {
      var value = String(text || '').toLowerCase();
      if (value.normalize) value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return value
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .split(' ')
        .map(function (word) {
          if (word.length <= 3) return word;
          return word.replace(/(sh|ss|ch|x)es$/, '$1').replace(/s$/, '');
        })
        .join(' ');
    }

    /* Categorias e subcategorias do menu (lidas da gaveta, que já vem sem as vazias), pela chave do nome.
       Servem para reconhecer uma busca sugerida que é o nome de uma categoria mesmo quando a busca da
       Shopify não devolve essa categoria ("lipstick" → Lipstick). */
    var menuCategories = {};
    if (menuDrawer) {
      $all('.mm-gaveta__link, .mm-gaveta__sublink', menuDrawer).forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (href.indexOf('/collections/') === -1) return;
        var title = (link.textContent || '').trim();
        var key = keyOf(title);
        if (key && !menuCategories[key]) menuCategories[key] = { title: title, url: href, key: key };
      });
    }

    function setOpen(open) {
      panel.hidden = !open;
      if (header) header.toggleAttribute('data-mm-ativo', open);
      if (!open && status) status.textContent = '';
    }

    function announce(text) {
      if (status) status.textContent = text;
    }

    function showStart(message) {
      if (result) result.hidden = true;
      if (start) start.hidden = false;
      if (emptyNote) {
        emptyNote.hidden = !message;
        emptyNote.textContent = message || '';
      }
    }

    function resultsHref(term) {
      return searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(term);
    }

    function fetchResults(term) {
      var key = term.toLowerCase();
      if (cache[key]) return cache[key];
      var url =
        suggestUrl +
        '.json?q=' +
        encodeURIComponent(term) +
        '&resources[type]=product,query,collection&resources[limit]=6&resources[limit_scope]=each';
      cache[key] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error(String(response.status));
          return response.json();
        })
        .then(function (data) {
          var results = (data && data.resources && data.resources.results) || {};
          return {
            products: (results.products || []).filter(function (product) {
              return !hideId || String(product.id) !== hideId;
            }),
            queries: results.queries || [],
            collections: results.collections || [],
          };
        })
        .catch(function () {
          delete cache[key];
          return null;
        });
      return cache[key];
    }

    function renderProducts(products, term) {
      if (!productList) return;
      productList.textContent = '';
      products.forEach(function (product) {
        var item = el('li');
        var link = el('a', 'mm-busca__produto');
        link.href = product.url;
        var image = product.featured_image && product.featured_image.url ? product.featured_image.url : product.image;
        if (image) {
          var img = doc.createElement('img');
          img.src = image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=96';
          img.alt = '';
          img.width = 48;
          img.height = 48;
          img.loading = 'lazy';
          link.appendChild(img);
        } else {
          link.appendChild(el('span', 'mm-busca__produto-sem-foto'));
        }
        var text = el('span');
        text.appendChild(el('span', 'mm-busca__produto-nome', product.title));
        var price = parseFloat(product.price);
        if (!isNaN(price)) text.appendChild(el('span', 'mm-busca__produto-preco', formatMoney(price, currency)));
        link.appendChild(text);
        item.appendChild(link);
        productList.appendChild(item);
      });
      if (allLink) {
        allLink.href = resultsHref(term);
        allLink.textContent = 'See all results for “' + term + '”';
      }
    }

    function termNode(text, typed) {
      var link = el('a', 'mm-busca__termo');
      var lower = text.toLowerCase();
      var index = lower.indexOf(typed.toLowerCase());
      var label = el('span');
      if (index === -1) {
        label.textContent = text;
      } else {
        label.appendChild(doc.createTextNode(text.slice(0, index)));
        label.appendChild(el('strong', '', text.slice(index, index + typed.length)));
        label.appendChild(doc.createTextNode(text.slice(index + typed.length)));
      }
      link.appendChild(label);
      return link;
    }

    /*
      Coluna das sugestões, em dois grupos com rótulo próprio (snippets/search.liquid):
      - "Categories": levam à página da categoria. Até 4. Primeiro as que têm o mesmo nome de uma busca
        sugerida (é o que a pessoa está digitando), depois as outras, na ordem da Shopify.
      - "Suggestions": levam ao resultado da busca e têm uma lupa no lugar do ponto. Até 4. Não entra a
        busca que é o nome de uma categoria (ela já está no grupo de cima; antes "lip oil" e "Lip Oil"
        apareciam na mesma lista) nem a de mais de 3 palavras (são pedaços de nome de produto, e o produto
        já aparece na coluna ao lado).
      Antes tudo vinha numa lista só, com o mesmo marcador e sem dizer o que era busca e o que era categoria.
    */
    var MAX_CATEGORIES = 4;
    var MAX_QUERIES = 4;
    var MAX_QUERY_WORDS = 3;

    function renderSuggestions(data, typed) {
      if (!suggestionList) return 0;
      suggestionList.textContent = '';
      if (categoryList) categoryList.textContent = '';

      /* Coleção sem produto à venda não é sugerida (a página dela abriria vazia). */
      var found = {};
      var fromSearch = [];
      data.collections.forEach(function (collection) {
        if (!collection.title || !collection.url || emptyPaths.indexOf(pathOf(collection.url)) !== -1) return;
        var key = keyOf(collection.title);
        if (!key || found[key]) return;
        found[key] = { title: collection.title, url: collection.url, key: key };
        fromSearch.push(found[key]);
      });

      var queries = data.queries.filter(function (query) {
        return query && query.text;
      });

      var used = {};
      var categories = [];
      queries.forEach(function (query) {
        var key = keyOf(query.text);
        var category = found[key] || menuCategories[key];
        if (!category || used[key]) return;
        used[key] = true;
        categories.push(category);
      });
      fromSearch.forEach(function (category) {
        if (used[category.key]) return;
        used[category.key] = true;
        categories.push(category);
      });
      categories = categories.slice(0, MAX_CATEGORIES);

      var terms = queries
        .filter(function (query) {
          return !used[keyOf(query.text)] && query.text.trim().split(/\s+/).length <= MAX_QUERY_WORDS;
        })
        .slice(0, MAX_QUERIES);

      /* sem o grupo próprio no HTML (página guardada de antes), as categorias vão para a lista única */
      var categoryTarget = categoryList || suggestionList;

      terms.forEach(function (query) {
        var text = query.text;
        var item = el('li');
        var link = termNode(text, typed);
        link.classList.add('mm-busca__termo--busca');
        link.href = query.url || resultsHref(text);
        var preview = function () {
          fetchResults(text).then(function (other) {
            if (!other || !other.products.length || input.value.trim() !== typed) return;
            $all('[data-ativo]', suggestionList).forEach(function (node) {
              node.removeAttribute('data-ativo');
            });
            link.setAttribute('data-ativo', '');
            renderProducts(other.products, text);
          });
        };
        link.addEventListener('pointerenter', preview);
        link.addEventListener('focus', preview);
        item.appendChild(link);
        suggestionList.appendChild(item);
      });

      categories.forEach(function (category) {
        var item = el('li');
        var link = termNode(category.title, typed);
        link.href = category.url;
        item.appendChild(link);
        categoryTarget.appendChild(item);
      });

      if (categoryGroup) categoryGroup.hidden = !categoryList || categories.length === 0;
      if (suggestionGroup) {
        suggestionGroup.hidden = categoryList ? terms.length === 0 : terms.length + categories.length === 0;
      }

      return categories.length + terms.length;
    }

    function search(term) {
      var id = ++requestId;
      fetchResults(term).then(function (data) {
        if (id !== requestId || input.value.trim() !== term) return;
        if (!data) {
          showStart('');
          return;
        }
        if (!data.products.length) {
          showStart('No products found for “' + term + '”. Try another word or browse a category.');
          announce('No products found');
          return;
        }
        announce(data.products.length === 1 ? '1 product found' : data.products.length + ' products found');
        var suggestions = renderSuggestions(data, term);
        renderProducts(data.products, term);
        if (result) {
          result.dataset.colunas = suggestions > 0 ? '2' : '1';
          result.hidden = false;
        }
        if (start) start.hidden = true;
      });
    }

    function onInput() {
      var term = input.value.trim();
      window.clearTimeout(timer);
      setOpen(true);
      if (term.length < 2) {
        requestId += 1;
        showStart('');
        return;
      }
      timer = window.setTimeout(function () {
        search(term);
      }, 180);
    }

    input.addEventListener('focus', onInput);
    input.addEventListener('input', onInput);
    /* depois de Esc o foco continua no campo: sem isto, clicar nele de novo não reabria o painel */
    input.addEventListener('click', function () {
      if (panel.hidden) onInput();
    });

    box.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || panel.hidden) return;
      /* sem isto o campo do tipo "search" apaga o texto e o painel reabre */
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(timer);
      requestId += 1;
      setOpen(false);
    });

    doc.addEventListener('pointerdown', function (event) {
      if (panel.hidden || box.contains(event.target)) return;
      setOpen(false);
    });

    box.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || box.contains(event.relatedTarget)) return;
      setOpen(false);
    });

    /* Lupa da linha do logo (só existe com o topo recolhido): devolve o topo inteiro e põe o cursor na busca. */
    $all('[data-mm-busca-abrir]').forEach(function (button) {
      button.addEventListener('click', function () {
        topo.expand();
        /* o campo acabou de voltar a ser visível: sem refazer o estilo antes, o foco pode não pegar */
        void box.offsetWidth;
        input.focus({ preventScroll: true });
        onInput();
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Rodapé: voltar ao topo                                           */
  /* ---------------------------------------------------------------- */
  function initVoltar() {
    $all('[data-mm-voltar-topo]').forEach(function (button) {
      button.addEventListener('click', function () {
        var behavior = reducedMotion() ? 'auto' : 'smooth';
        var wrapper = pageWrapper();
        if (wrapper && wrapper.scrollTop > 0) wrapper.scrollTo({ top: 0, behavior: behavior });
        window.scrollTo({ top: 0, behavior: behavior });
        var skip = $('#MainContent');
        if (skip) {
          skip.setAttribute('tabindex', '-1');
          skip.focus({ preventScroll: true });
        }
      });
    });
  }

  function init() {
    initAviso();
    initRolagem();
    initMenu();
    initGaveta();
    initDesejos();
    initBusca();
    initVoltar();
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
